import React from 'react';
import { CheckCircle, X } from 'react-feather';

type Props = {
  check: number;
  size?: number;
  classname?: string;
};

export const Checkmark = ({ check, size = 18, classname }: Props) => {
  const icon = check === 1 ? <CheckCircle size={size} /> : <X size={size} />;
  const style = check === 1 ? 'text-green-500' : 'text-red-700';

  return <span className={`${style} text-sm ${classname}`}>{icon}</span>;
};

export default Checkmark;
